<!--
     Copyright (c) 2023-2025 Broadcom. All Rights Reserved.
     Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
     and/or its subsidiaries.
-->
<div class="title-box">
    <input type="radio"
           class="clr-radio"
           [value]="value"
           [id]="id"
           [name]="name"
           [(ngModel)]="model"/>
    <label [for]="id" class="clr-control-label">
        {{ label }}
    </label>
</div>
<div *ngIf="icon" class="icon-box">
    <cds-icon [attr.shape]="icon"
              [size]="iconSize">
    </cds-icon>
</div>
<div class="description"
     *ngIf="description"
     [innerHTML]="description">
</div>
<div class="outside-content">
    <ng-content></ng-content>
</div>

